var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"cmsCategoryTree",attrs:{"data":_vm.treeData,"show-checkbox":"","node-key":"id","props":_vm.defaultProps,"default-checked-keys":_vm.grantValues},on:{"check-change":_vm.onCmsCategoryCheckChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }